import CheckboxGroup from '../../Common/CheckboxGroup';
import { FieldErrors, UseFormSetValue } from 'react-hook-form';
import { OptionItem } from '../../../types/components/common/select';
import { useMemo } from 'react';
import { RespondentFormData } from '../../../types/sdq';

interface Props {
  setValue: UseFormSetValue<RespondentFormData>;
  values?: number[];
  formErrors: FieldErrors<RespondentFormData>;
  fieldKey: 'additional_question_response_group';
  /**
   * 例: 'responses.0.choices'
   */
  nestedFieldKey: string;
  options: OptionItem[];
}

function validateChoicesFieldKey(nestedFieldKey: string): void {
  const regex = /^responses\.\d+\.choices$/;
  if (!regex.test(nestedFieldKey)) {
    throw new Error(`Invalid nestedFieldKey: ${nestedFieldKey}`);
  }
}

export const CheckboxGroupField = ({ setValue, values, formErrors, fieldKey, nestedFieldKey, options }: Props) => {
  validateChoicesFieldKey(nestedFieldKey);
  const keys = nestedFieldKey.split('.').map((v) => Number(v));
  const responseIndex = keys[1];

  const currentValues = useMemo(() => (values ?? []).map((v) => v.toString()), [values]);

  const handleOnChange = (newValues: string[]) => {
    // fieldKey はリテラル型なので、テンプレートリテラル型で react-hook-form の Path に解決できる
    // （RadioGroupField の @ts-ignore を増やさないため、型で通す）
    const name: `additional_question_response_group.responses.${number}.choices` = `${fieldKey}.responses.${responseIndex}.choices`;
    setValue(name, newValues.map(Number));
  };

  const errorMessage = useMemo(() => {
    return formErrors[fieldKey]?.responses?.[responseIndex]?.choices?.message;
  }, [formErrors, fieldKey, responseIndex]);

  return (
    <CheckboxGroup values={currentValues} onChange={handleOnChange} options={options} errorMessage={errorMessage} />
  );
};
